import { ref, computed } from 'vue';
/**
 * Every expandable must have a unique id to define if it active.
 * As the id we use unique integer number that id incremented every
 * time a new expandable is created
 **/

let id = 0;

/**
 * Simultaneously only one expandable transition can be opened.
 * To implement this logic we need a global state that contains
 * currently active (opened) expandable
 **/
const activeId = ref();
const getId = (isRadio?: boolean) => (isRadio ? id++ : 0);

export function useExpandableTransition(isRadio?: boolean) {
  const transitionId = getId(isRadio);
  const isExpandedSingle = ref(false);

  const open = () => {
    if (isRadio) {
      activeId.value = transitionId;
    } else {
      isExpandedSingle.value = true;
    }
  };

  const isExpanded = computed(() =>
    isRadio ? activeId.value === transitionId : isExpandedSingle.value,
  );

  const close = () => {
    isExpandedSingle.value = false;
    activeId.value = '';
  };

  return {
    open,
    isExpanded,
    close,
  };
}
